import React from 'react';
import { CheckCircleIcon, PlusCircleIcon, FileTextIcon, RefreshCwIcon } from 'lucide-react';
interface ConfirmationScreenProps {
  onNew: () => void;
  onHome: () => void;
  onSync: () => void;
}
export function ConfirmationScreen({
  onNew,
  onHome,
  onSync
}: ConfirmationScreenProps) {
  return <div className="flex flex-col h-full w-full bg-white px-6 py-10" data-id="element-51">
      <div className="flex-1 flex flex-col items-center justify-center text-center" data-id="element-52">
        <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mb-6" data-id="element-53">
          <CheckCircleIcon className="w-14 h-14 text-green-500" data-id="element-54" />
        </div>

        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-55">¡Guardada!</h1>
        <p className="text-lg text-gray-600 mb-8" data-id="element-56">
          La recolección se ha registrado correctamente en el dispositivo.
        </p>

        <div className="bg-gray-50 border border-gray-200 rounded-2xl p-5 w-full mb-8 text-left" data-id="element-57">
          <div className="flex justify-between mb-2" data-id="element-58">
            <span className="text-gray-500" data-id="element-59">Área:</span>
            <span className="font-bold text-gray-900" data-id="element-60">Emergencia</span>
          </div>
          <div className="flex justify-between mb-2" data-id="element-61">
            <span className="text-gray-500" data-id="element-62">Total prendas:</span>
            <span className="font-bold text-gray-900" data-id="element-63">45</span>
          </div>
          <div className="flex justify-between" data-id="element-64">
            <span className="text-gray-500" data-id="element-65">Fecha:</span>
            <span className="font-medium text-gray-900" data-id="element-66">Hoy, 10:45 AM</span>
          </div>
        </div>
      </div>

      <div className="flex flex-col gap-4 mt-auto" data-id="element-67">
        <button onClick={onNew} className="w-full h-14 rounded-xl text-white font-bold text-lg flex items-center justify-center gap-2 active:scale-[0.98] transition-transform shadow-md" style={{
        backgroundColor: '#134073'
      }} data-id="element-68">
          <PlusCircleIcon className="w-6 h-6" data-id="element-69" />
          Nueva Recolección
        </button>

        <button onClick={onSync} className="w-full h-14 rounded-xl font-bold text-lg flex items-center justify-center gap-2 active:scale-[0.98] transition-transform border-2" style={{
        borderColor: '#3d99d2',
        color: '#3d99d2'
      }} data-id="element-70">
          <RefreshCwIcon className="w-6 h-6" data-id="element-71" />
          Sincronizar Ahora
        </button>

        <button onClick={onHome} className="w-full h-14 rounded-xl text-gray-600 font-bold text-lg flex items-center justify-center gap-2 active:bg-gray-50 transition-colors" data-id="element-72">
          Volver al Inicio
        </button>
      </div>
    </div>;
}